import { getSessionInfo } from '../utils/getSessionInfo';

import { useAppSelector } from './../store/storeConfig';

export const useAuthenticate = () => {
	const { authenticated } = useAppSelector((state) => state.authSlice);

	const userInfo = getSessionInfo();

	return authenticated || !!userInfo?.userInfo?._id;
};
